import React, { useState, useEffect } from "react";
import { 
  Spinner, 
  // ToggleButton 
} from "@public/ui-toolkit";
import { Search } from "@hedgefund/shared";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { aumData } from "../SearchHedgeFund";
import { getRegion, getSubspecialties, getStrategies } from "../SearchHedgeFund/actions";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  getFundSpotlight,
  getListOfStrategies,
  getRecentChats,
  getMeetings,
  getRecentPost,
  getDashboardConfig,
  updateDashboardConfig,
} from "./actions";
import moment from "moment";
import FundWatchList from "./components/FundWatchList";
import NewsFeed from "./components/NewsFeed";
import RecentChat from "./components/RecentChat";
import FundStrategies from "./components/FundStrategies";
import RecentMeetings from "./components/RecentMeetings";
import FundPerformance from "./components/FundPerformance";
import FundSpotlight from "./components/FundSpotlight";
import MyFunds from "./components/MyFunds";
import { Avatar, Space } from "antd";

const fundColumn = [
  { name: "Name", key: "name" },
  { name: "Strategy", key: "strategyTitle" },
  { name: "Monthly Returns", key: "monthlyReturn", toFixed: 2 },
];

const recentChatColumn = [
  {
    name: "Name",
    key: "roomName",
    renderContent: (item) => {
      return (
        <Space size={2}>
          <Avatar src={item.profileImage} /> {item.roomName}
        </Space>
      ) 
    }
  },
  {
    name: "Message",
    key: "body",
    renderContent: (item) => {
      return (
        <>
          {item.body != null ? item.body?.includes("<style>") ? "Meeting Invitation" : item?.body?.substring(0, 60) + "....." : "File Sent"}
        </>
      )
    }
  },
];

const listOfStrategyColumn = [
  { name: "Name", key: "name" },
  { name: "Fund Total", key: "count" },
];

const MeetingsColumn = [
  { name: "Topic", key: "title" },
  { name: "HedgeFund", key: "hedgeFundName" },
  {
    name: "Date",
    key: "startTime",
    type: "date",
    format: (date) => moment(date).format("DD MMM YYYY"),
  },
  {
    name: "Start Time",
    key: "startTime",
    type: "date",
    format: (date) => moment(date, "hh:mm:ss").format("LT"),
  },
];

const PMDropdownConf = [
  { name: "YTD", id: 1 },
  { name: "Monthly Return", id: 2 },
];

const Dashboard = () => {
  const history = useHistory();

  const [dndState, setDndState] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [strategyFilter, setStrategyFilter] = useState("");
  const [regionFilter, setRegionFilter] = useState("");
  const [aumFilter, setAumFilter] = useState("");
  const [subSpecialtyFilter, setSubSpecialtyFilter] = useState("");

  const [fundPerformanceColumn, setFundPerformanceColumn] = useState([
    { name: "Name", key: "name" },
    { name: "Strategy", key: "strategyTitle" },
    { name: "YTD", key: "monthlyReturn", toFixed: 2 },
  ]);

  const changeFundPerformance = (e) => {
    const updatedCol = Object.assign({}, fundPerformanceColumn[2], {
      name: parseInt(e) === 1 ? "YTD" : "Monthly Return",
    });
    dispatch(getFundSpotlight(parseInt(e) === 1 ? true : false));
    setFundPerformanceColumn([
      ...fundPerformanceColumn.slice(0, 2),
      updatedCol,
    ]);
  };

  const dashboardState = useSelector((state) => state.dashboard);
  const getStrategyState = useSelector(
    (state) => state.SearchHedgeFundStore.companyStrategyData
  );
  const { regions } = useSelector((state) => state.SearchHedgeFundStore);

  const getSubSpecialtyState = useSelector(
    (state) => state.SearchHedgeFundStore.subSpecialties
  );
  const strategiesList = [
    {
      id: 29,
      name: "All",
      isExistFund: false,
      creationTime: null,
      creatorUserId: null,
    },
    ...getStrategyState,
  ];

  const regionList = [
    {
      name: "All",
      id: 6,
    },
    ...regions,
  ];
  const subSpecialtyList = [
    {
      id: 29,
      name: "All",
      isExistFund: false,
      creationTime: null,
      creatorUserId: null,
    },
    ...getSubSpecialtyState,
  ];
  const {
    getFundDashboard,
    getStrategyList,
    getRecentChat,
    getMeeting,
    recentPosts,
    dashboardConfigResult,
    loading,
    spotlightLoading,
  } = dashboardState;
  const {
    fundSnapShot = [],
    fundWatchList = [],
    fundSpotLight = [],
    myFunds = [],
  } = getFundDashboard;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDashboardConfig(dashboardApiCalls));
  }, [dispatch]);

  useEffect(() => {
    setDndState(
      dashboardConfigResult.sort((ele1, ele2) => {
        return ele1.orderNo - ele2.orderNo;
      })
    );
  }, [dashboardConfigResult]);

  const updateDashboardConfigClick = () => {
    let payload = dndState.map((config) => {
      return {
        widgetId: config.widgetId,
        isHide: config.isHide,
        orderNo: config.orderNo,
      };
    });
    dispatch(
      updateDashboardConfig(payload, () => {
        dispatch(getDashboardConfig(dashboardApiCalls));
      })
    );
  };

  const dashboardApiCalls = () => {
    dispatch(getRegion());
    dispatch(getStrategies());
    dispatch(getFundSpotlight(true));
    dispatch(getListOfStrategies());
    dispatch(getRecentChats());
    dispatch(getMeetings());
    dispatch(getRecentPost());
    dispatch(getSubspecialties());
  };

  const handleSearch = (text) => setSearchValue(text);

  const onSubmitSearchHandler = (e) => {
    e.preventDefault();
    history.push(
      `/hedgefunds?keyword=${searchValue}&dropDownValue=${strategyFilter}&dropDownSubspecialtyValue=${subSpecialtyFilter}&dropDownAumValue=${aumFilter}&dropDownRegionValue=${regionFilter}`
    );
  };
  const dashboardComponents = {
    1: (
      <Search
        headTitle={"Search Funds"}
        setSearchValue={setSearchValue}
        handleSearch={handleSearch}
        dropDownData={strategiesList}
        onSubmit={onSubmitSearchHandler}
        strategyFilter={strategyFilter}
        onChangeStrategy={(e) => {
          setStrategyFilter(e.value)
          // dispatch(getSubspecialties());
        }}
        aumFilter={aumFilter}
        onChangeAum={(e) => setAumFilter(e.label)}
        aumData={aumData}
        subSpecialtyDropDown={subSpecialtyList}
        subSpecialtyFilter={subSpecialtyFilter}
        onChangeSubSpecialty={(e) => setSubSpecialtyFilter(e.value)}
        regionFilter={regionFilter}
        onChangeRegion={(e) => setRegionFilter(e.value)}
        regionDropDownData={regionList}
        title="Search Funds"
      />
    ),
    2: (
      <FundWatchList
        columns={fundColumn}
        data={fundWatchList}
        onRowClick={(row) => history.push(`/hedgefund/${row.hedgeFundId}/${row.id}`)}
      ></FundWatchList>
    ),
    3: <NewsFeed data={recentPosts}></NewsFeed>,
    4: (
      <RecentChat columns={recentChatColumn} data={getRecentChat}></RecentChat>
    ),
    5: (
      <FundStrategies
        columns={listOfStrategyColumn}
        data={getStrategyList}
        onRowClick={(row) => history.push(`/hedgefunds?dropDownValue=${row?.id}`)}
      ></FundStrategies>
    ),
    6: (
      <RecentMeetings
        columns={MeetingsColumn}
        data={getMeeting}
      ></RecentMeetings>
    ),
    7: (
      <FundPerformance
        columns={fundPerformanceColumn}
        data={fundSnapShot}
        onRowClick={(row) => history.push(`/hedgefund/${row.hedgeFundId}/${row.id}`)}
        dropDownData={PMDropdownConf}
        loading={spotlightLoading}
        onChangeOption={changeFundPerformance}
      ></FundPerformance>
    ),
    8: (
      <FundSpotlight
        columns={fundColumn}
        data={fundSpotLight}
        onRowClick={(row) => history.push(`/hedgefund/${row.hedgeFundId}/${row.id}`)}
      ></FundSpotlight>
    ),
    9: (
      <MyFunds
        columns={fundColumn}
        data={myFunds}
        onRowClick={(row) => history.push(`/hedgefund/${row.hedgeFundId}/${row.id}`)}
      ></MyFunds>
    ),
  };
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    result.forEach((ele, index) => {
      ele.orderNo = index + 1;
    });

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      dndState,
      result.source.index,
      result.destination.index
    );

    setDndState(items);
    updateDashboardConfigClick();
  };

  return (
    <main>
      <div className="main-inner">
        <div className="container">
          <div className="main-content-header py-4"></div>
          {loading ? (
            <Spinner className="text-center" />
          ) : (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    className="row gx-3 gy-3"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {dndState?.map((widget, index) => {
                      return (
                        <Draggable
                          key={index.toString()}
                          draggableId={widget.widgetId.toString()}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              className="col-md-6 col-xl-4"
                              ref={provided.innerRef}
                              snapshot={snapshot}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{ ...provided.draggableProps.style }}
                            >
                              <div
                                style={{ position: "relative", height: "100%" }}
                              >
                                {dashboardComponents[widget.widgetId]}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
